/**
 * Import required libraries
 */
import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import { labelFromPath } from "Utils";

/**
 * Import required elements
 */
import NewChat from "./NewChat";
import Chatbox from "./Chatbox";
import Notifications from "./Notifications";
import { Divider } from "@material-ui/core";
// Material-ui icons
import {
  AddComment as NewChatIcon,
  Chat as ChatboxIcon,
  Notifications as NotificationsIcon
} from "@material-ui/icons";
import ButtonPopup from "./ButtonPopup";

import styles from "./styles";
import ChatSelector from "./ChatSelector";
import GroupIcon from '@material-ui/icons/Group';
import ListIcon from '@material-ui/icons/List';

const defaultButtons = {
  newChat: {
    Popup: NewChat,
    Icon: NewChatIcon
  },
  selectorPrivateChat: {
    Popup: ChatSelector,
    Icon: ListIcon

  },
  selectorProjectChat: {
    Popup: ChatSelector,
    Icon: ListIcon
  },
  notifications: {
    Popup: Notifications,
    Icon: NotificationsIcon,
    popupStyle: {
      left: "calc(-100% - 185px)"
    }
  }
};


const labelPath = "footer";

/**
 * Footer Component
 */
function Footer(props) {

  //Concerne les chats privés
  let chats = useMemo(() => {
    return props.chats.filter(c => c.users.includes(props.user.userUid));
  }, [props.chats, props.user.userUid]);

  const uidGroup = props.group.chat;

  let chatGroupUser = useMemo(() => {
    return props.chats.filter(c => c.uid === uidGroup);
  }, [props.chats, uidGroup]);

  // Concerne les chats de groupes
  //  let chatGroupsUser = useMemo(() => {
  //   console.log("props.group :", props.group)
  //   console.log("props.project :", props.project)
  //   let _groups = Object.keys(props.group).filter(k => {
  //     return props.group[k].users.includes(props.user.userUid)
  //   })
  //   return props.chats.filter(c => {
  //     let add = false;

  //     for(const property of _groups){
  //       if(props.group[property].chat === c.uid){
  //        add = true;
  //       }
  //     }
  //     return add;

  //    });
  // }, [props.chats,props.group, props.user.userUid]);

  // Concerne les chats de projets
  let chatProjectUser = useMemo(() => {
    let _projects = Object.keys(props.project).filter(k => {
      return props.project[k].users.includes(props.user.userUid)
    })
    return props.chats.filter(c => {
      let add = false;

      for (const property of _projects) {
        if (props.project[property].chat === c.uid) {
          add = true;
        }
      }
      return add;

    });
  }, [props.chats, props.project, props.user.userUid]);

  //Gere l'ouverture et la fermeture des onglets de chats
  const [opened, setOpen] = useState(chats.reduce((obj, { uid }) => {
    obj[uid] = false;
    return obj;
  }, {
    newChat: false,
    selectorPrivateChat: false,
    selectorProjectChat: false,
    notifications: false
  }));

  //Gere la visibilité des onglets de chats
  const [visible, setVisible] = useState(chats.reduce((obj, { uid }) => {
    obj[uid] = false;
    return obj;
  }, {
    newChat: true,
    selectorPrivateChat: true,
    selectorProjectChat: true,
    notifications: true
  }));

  // CSS classnames
  const classes = styles();


  // On aura toujours qu'un seul onglet ouvert à la fois
  const open = (uid, _opened) => event => {
    event.preventDefault();
    setOpen(obj => Object.assign({}, obj, {
      [uid]: _opened
    }));
    for (const property in opened) {
      if (property !== uid && opened[property] === true) {
        setOpen(obj => Object.assign({}, obj, {
          [property]: false
        }));
      }
    }
  }

  const makeVisible = (uid, _visible) => {
    setVisible(obj => Object.assign({}, obj, {
      [uid]: _visible
    }));
  }


  const _label = key => labelFromPath(labelPath, key, props.lang);
  //console.log("chatProjectUser",chatProjectUser);

  //Problème de timestamp non utilisable : le timestamp d'un chat correspond à la dernière fois qu'un message a été posté sur ce chat
  //Nous voulons savoir la date de la dernière fois que le chat a été ouvert par l'utilisateur
  /*
    function countBool(obj,boo){
      let cpt = 0;
      for(const prop in obj){
        //console.log("prop:",prop)
        if(obj[prop]===boo){
          cpt++;
        }
      }
      return cpt
    }
  
    useEffect(() => {
      console.log("visible :", visible)
      let tmp = Object.assign([],chats)
      console.log("tmp avant :",tmp)
      //tmp.sort(function(a, b){return b.timestamp - a.timestamp})
      //console.log("tmp après :",tmp)
  
        let n = countBool(visible,true) - 4; // 4 objets statiques
        console.log("n:",n)
      if(n > 3){
        let newVisible = Object.assign({},visible);
        //newVisible[newVisible.length-1] = false;
        setVisible(newVisible);
      }
  
    },[visible])
  */

  function ListOfChat(props) {
    let { chatArray, Icon } = props
    return chatArray.map(({ uid, name }, idx) =>
    (
      (visible[uid]) === true && (
        <ButtonPopup key={uid}
          opened={opened[uid]}
          makeVisible={e => makeVisible(uid, false)}
          open={open(uid, !opened[uid])}
          close={open(uid, false)}
          label={name}
          Popup={Chatbox}
          popupProps={{ uid, labelPath }}
          Icon={Icon}
        />)
    )
    )
  }

  function ChatBrowser(props) {
    let { chatArray, label, selectorName } = props
    return chatArray.length > 0 &&
      <React.Fragment>
        <ButtonPopup {...defaultButtons[selectorName]}
          popupProps={{ labelPath, makeVisible, chats: chatArray }}
          label={_label(label)}
          opened={opened[selectorName]}
          open={open(selectorName, !opened[selectorName])}
          close={open(selectorName, false)}
        />
        <Divider orientation="vertical" flexItem />
      </React.Fragment>
  }

  return (
    <div className={classes.footer}>
      <div className={classes.left}>
        {/* Creation de chat
        */}
        <ButtonPopup {...defaultButtons.newChat}
          popupProps={{ labelPath, makeVisible }}
          opened={opened.newChat}
          open={open("newChat", !opened.newChat)}
          close={open("newChat", false)}
        />

        <Divider orientation="vertical" flexItem />
        {/* Accès au chat du groupe
        */}

        <ListOfChat name={"chatsGroup"} chatArray={chatGroupUser} Icon={GroupIcon} />
        {/* {chatGroupUser.map(({uid, name}, idx) =>
          (
            <ButtonPopup key={uid}
              opened={opened[uid]}
              open={open(uid, !opened[uid])}
              close={open(uid, false)}
              label={name}
              Popup={Chatbox}
              popupProps={{ uid, labelPath }}
              Icon={GroupIcon}
            />)
        )}  */}

        <Divider orientation="vertical" flexItem />


        {/* Accès au chat de projets
        */}
        {/* {chatProjectUser.length>0 &&
        <React.Fragment>
          <ButtonPopup {...defaultButtons.selectorProjectChat}
          popupProps={{labelPath,makeVisible,chats:chatProjectUser}}
          label={_label("projects")}
          opened={opened.selectorProjectChat}
          open={open("selectorProjectChat", !opened.selectorProjectChat)}
          close={open("selectorProjectChat", false)}
        />
        <Divider orientation="vertical" flexItem />
        </React.Fragment>
        } */}

        <ChatBrowser chatArray={chatProjectUser} label={"projects"} selectorName={"selectorProjectChat"} />

        {/* //On parcours tous les chats de l'utilisateur dans le footer
          Pour l'instant on affiche que les 3 derniers chats créé
        */}


        <ListOfChat chatArray={chatProjectUser} Icon={ChatboxIcon} />
        {/* {chatProjectUser.map(({uid, name}, idx) =>
          
          (visible[uid])===true && (
          <ButtonPopup key={uid}
            opened={opened[uid]}
            makeVisible={e => makeVisible(uid,false)}
            open={open(uid, !opened[uid])}
            close={open(uid, false)}
            label={name}
            Popup={Chatbox}
            popupProps={{ uid, labelPath }}
            Icon={ChatboxIcon}
          />)
        )}  */}


        <Divider orientation="vertical" flexItem />

        {/* Accès au chat privés
        */}
        {/* {chats.length>0 &&
        <React.Fragment>
          <ButtonPopup {...defaultButtons.selectorPrivateChat}
          popupProps={{labelPath,makeVisible,chats:chats}}
          label={_label("privates")}
          opened={opened.selectorPrivateChat}
          open={open("selectorPrivateChat", !opened.selectorPrivateChat)}
          close={open("selectorPrivateChat", false)}
        />
        <Divider orientation="vertical" flexItem />
        </React.Fragment>
        } */}

        <ChatBrowser chatArray={chats} label={"privates"} selectorName={"selectorPrivateChat"} />



        {/* //On parcours tous les chats de l'utilisateur dans le footer
          Pour l'instant on affiche que les 3 derniers chats créé
        */}
        <ListOfChat name={"chats"} chatArray={chats} Icon={ChatboxIcon} />
        {/* {chats.map(({uid, name}, idx) =>
          
          (visible[uid])===true && (
          <ButtonPopup key={uid}
            opened={opened[uid]}
            makeVisible={e => makeVisible(uid,false)}
            open={open(uid, !opened[uid])}
            close={open(uid, false)}
            label={name}
            Popup={Chatbox}
            popupProps={{ uid, labelPath }}
            Icon={ChatboxIcon}
          />)
        )}  */}
      </div>



      <ButtonPopup {...defaultButtons.notifications}
        popupProps={{ labelPath }}
        opened={opened.notifications}
        open={open("notifications", !opened.notifications)}
        close={open("notifications", false)}
      />


    </div>
  );
}

export default connect(state => ({
  lang: state.locale.lang,
  user: state.user,
  group: state.list.group[state.user.groupUid],
  info: state.list.group,
  project: state.list.project,
  users: state.list.user,
  chats: Object.values(state.list.chat || {})
}))(Footer);
